export default {
  'validation.required': 'This field is required.',
  'validation.type.number': 'Please enter a valid number.',
  'validation.type.number.min': 'Please enter a value greater than {number}.',
  'validation.type.number.max': 'Please enter a value less than or equal to {number}.',
  'validation.type.string.min': 'Please enter at least {number} characters.',
  'validation.type.string.max': 'Please enter at most {number} characters.',
  'validation.type.date.greaterthan.today': 'Date cannot be in the future.',
  'validation.type.number.range': 'Please enter a value between 0 and {number}.',
  'validation.type.string.length.range':
    'Please enter a value with a length between {min} and {max} characters.',
  'validation.bcp47': 'Please use BCP 47 format.',
  'validation.type.string.guid': 'Invalid format. Please use GUID format.',
  'validation.type.date': 'Invalid date format.',
  'validation.type.array.values.string': 'Please enter at between {min} and {max} characters.',
  'validation.type.phoneNumber': 'Please enter a valid phone number.',
  'validation.type.email': 'Please enter a valid email address.',
  'validation.type.email.maxLength': 'Please enter at most 100 characters.',
  'validation.gender.type.enum': 'Gender must be either Male or Female',
  'validation.type.date.future': 'Date must be in the future.',
  'validation.type.date.past': 'Date must be in the past.',
  'validation.idNo.invalid': 'ID number must be a valid Turkish ID number.',
  'validation.passportNo.invalid': 'Please enter a valid passport number format (6-20 characters, letters and numbers).',
};
